export const CLEAR_TABLE = "CLEAR_TABLE";
export const TOGGLE_STATE_EMPLOYEE = "TOGGLE_STATE_EMPLOYEE";
export const GET_EMPLOYEES_ASSOCIATED = "GET_EMPLOYEES_ASSOCIATED";
export const SELECT_ALL = "SELECT_ALL";
export const UNSELECT_ALL = "UNSELECT_ALL";
export const FILTER_EMPLOYEES_ASSOCIATION = "FILTER_EMPLOYEES_ASSOCIATION";
export const FILTER_TAGS_WITH_NAMETAGS = "FILTER_TAGS_WITH_NAMETAGS";
